import httpManager from "@/app/shared/utils/httpManager";

/**
 * Actualiza nuevo Correo electronico.
 * @param {number} referralsId Identificador del referido
 * @param {Object} body Datos del correo.
 *
 * @return {Promise<Object>} Datos del correo creado
 */
export async function createReferralsContact(referralsId, body) {
  const response = await httpManager.post(`/contacts/clients/${referralsId}/contacts/`, body);
  return response?.data;
}
